import React, { useEffect, useState } from 'react'
// navigation
import { useNavigate } from 'react-router-dom'
// context, state and remote data
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext'
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown'
import ChangeEmailLink from 'src/viewLayer/components/shared/HintLinks/ChangeEmailLink'
import PasswordInput from 'src/viewLayer/components/shared/Inputs/PasswordInput'
import { MagicLink } from 'src/viewLayer/components/shared/MagicLink/MagicLink'
import { t } from 'src/viewLayer/helpers/translations'

import { showMagicLink, useEmailPagePath } from '../../../navigation'
import TrackableButton from '../../shared/TrackableButton'
import BackButton from '../BackButton'
// view components
import CardLayout from '../CardLayout'
import ForgotPasswordLink from './ForgotPasswordLink'
import PasswordImage from './Images/Password.svg'
import {
  ActionsContainer,
  FormContainer,
  InputFrame,
  LoginPasswordPageContainer,
} from './index.styled'

export default function LoginPasswordPage({
  appType,
  captchaFeature,
  email,
  errorKey,
  isFocused,
  isPasswordLoginInProgress,
  onChange,
  onSubmit,
  password,
  path,
}) {
  const navigate = useNavigate()
  const emailPagePath = useEmailPagePath()
  const { devicePath } = useAppConfigContext()
  const [isMagicLinkInProgress, setIsMagicLinkInProgress] = useState(false)
  const isFormLocked = isPasswordLoginInProgress || isMagicLinkInProgress
  const shouldShowMagicLink = devicePath === 'login' || showMagicLink()

  useTrackPageShown({ appType, pageType: path })
  useEffect(() => {
    if (!email) {
      navigate(emailPagePath, { replace: true })
    }
  }, [email, emailPagePath, navigate])

  const handleOnSubmit = (event) => {
    event.preventDefault()
    event.stopPropagation()
    if (password.length > 0 && !isFormLocked) {
      onSubmit()
    }
  }

  const magicLink = shouldShowMagicLink ? (
    <MagicLink
      email={email}
      isPasswordLoginInProgress={isPasswordLoginInProgress}
      setIsMagicLinkInProgress={setIsMagicLinkInProgress}
    />
  ) : null

  return (
    <LoginPasswordPageContainer>
      <CardLayout
        email={email}
        Image={PasswordImage}
        isPasswordPage
        magicLink={magicLink}
        subtitle={email}
        title={t('password.title')}
      >
        <ChangeEmailLink />
        <BackButton path={path} trackingId="backbutton-password-to-email" />
        <FormContainer>
          <form onSubmit={handleOnSubmit}>
            <InputFrame>
              <PasswordInput
                disabled={isFormLocked}
                errorKey={errorKey}
                isFocused={isFocused}
                onChangeHandler={onChange}
                value={password}
              />
            </InputFrame>
          </form>
          <ForgotPasswordLink email={email} />
          {captchaFeature}
          <ActionsContainer>
            <TrackableButton
              disabled={password.length === 0 || isFormLocked}
              id="uat-continue-button"
              inProgress={isPasswordLoginInProgress}
              onClick={handleOnSubmit}
              trackingId="password_submit"
            >
              {t('password.button.login')}
            </TrackableButton>
          </ActionsContainer>
        </FormContainer>
      </CardLayout>
    </LoginPasswordPageContainer>
  )
}
